<template>
  <header id="header">
    <div class="containers">
      <div class="row" v-if="loginHeader === true">
        <div class="col-md-6 align-self-center">
          <a href="#" class="logo">
            <img
              src="../assets/images/taxpoint_black.png"
              alt=""
              style="height: 35px !important"
            />
          </a>
        </div>
        <div class="col-md-6 align-self-center">
          <div class="select-languages">
            <div class="form">
              <select>
                <option value="English">Eng</option>
              </select>
            </div>
            <div class="img-wrapper">
              <i class="fa-solid fa-circle-question"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="row main-header" v-if="mainHeader === true">
        <div class="col-md-3 align-self-end">
          <RouterLink to="/home" class="logo">
            <img
              src="../assets/images/taxpoint_black.png"
              alt=""
              style="height: 35px !important"
            />
          </RouterLink>
        </div>

        <div class="col-md-10 align-self-end">
          <ul class="menu">
            <li>
              <RouterLink to="/home" class="text-black">Dashboard</RouterLink>
            </li>
            <li>
              <RouterLink to="/items" class="text-black">Items</RouterLink>
            </li>
            <li>
              <RouterLink to="/sales" class="text-black">Sales</RouterLink>
            </li>
            <li>
              <RouterLink to="/credit" class="text-black"
                >Credit Note</RouterLink
              >
            </li>
            <li>
              <RouterLink to="/customer" class="text-black"
                >Customers</RouterLink
              >
            </li>
            <li>
              <RouterLink to="/purchases" class="text-black"
                >Purchases</RouterLink
              >
            </li>
            <li>
              <RouterLink to="/imports" class="text-black">Imports</RouterLink>
            </li>
            <!-- <li><RouterLink to="/profoma">Profoma</RouterLink></li> -->
            <!-- <li><RouterLink to="/movement">Stock Movement</RouterLink></li> -->
            <li>
              <RouterLink to="/insurance" class="text-black"
                >Insurances</RouterLink
              >
            </li>
            <li>
              <RouterLink to="/user" class="text-black">Users</RouterLink>
            </li>
            <li>
              <RouterLink to="/notice" class="text-black"
                >Notices & Branch</RouterLink
              >
            </li>
            <li>
              <RouterLink :to="{ name: 'Reports' }" class="text-black"
                >Reports</RouterLink
              >
            </li>
            <li>
              <RouterLink :to="{ name: 'Settings' }" class="text-black"
                >Settings</RouterLink
              >
            </li>
          </ul>
        </div>
        <div class="col-md-2 align-self-end">
          <ul class="info">
            <li>
              <div class="dropdown">
                <div
                  class="dropdown-toggle bg-white border-white important text-black"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style="cursor: pointer"
                >
                  {{ removeQuotes(user) }}
                </div>
                <ul class="dropdown-menu dropdown-menu-end text-center p-0">
                  <li>
                    <router-link
                      class="dropdown-item"
                      to="#"
                      @click.prevent="logOut"
                      >Log Out</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <!-- <li>
              <div class="bell-icon" style="cursor: pointer">
                <img
                  src="../assets/images/icons/bell-icon.svg"
                  style="width: 27px !important; height: auto !important"
                  alt=""
                />
              </div>
            </li> -->
            <li>
              <div class="question-mark" style="cursor: pointer">
                <img
                  src="../assets/images/icons/question-mark-circle.png"
                  style="width: 25px !important; height: auto !important"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { useAuthStore } from "@/stores/authStore";

export default {
  name: "FooterComponent",
  props: ["loginHeader", "mainHeader"],

  data: () => ({
    user: "",
    check: false,
  }),

  methods: {
    removeQuotes(str) {
      if (typeof str !== "string") return str;

      if (str.startsWith('"') && str.endsWith('"') && str.length >= 2) {
        return str.slice(1, -1);
      } else {
        return str;
      }
    },

    logOut() {
      alert("Logging out");
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");

      const authStore = useAuthStore();
      authStore.logout();

      this.user = null;
      this.$router.push("/");
    },

    async loginStatus() {
      if (this.$route.path !== "/") {
        if (!this.status) {
          this.$router.push("/");
        }
      }
    },
  },

  mounted() {
    let user = localStorage.getItem("user");
    this.user = user ? this.removeQuotes(user) : user;

    this.loginStatus();
  },
  computed: {
    status() {
      return useAuthStore().isLoggedIn;
    },
  },
  created() {
    this.$watch(
      () => useAuthStore().isLoggedIn,
      (value) => {
        this.check = value;
      },
      {
        immediate: true,
      }
    );
  },
};
</script>

<style scoped>
.menu li *:hover {
  /* font-weight: bold !important; */
  text-decoration: underline;
  text-decoration-color: #26bf9b;
}
</style>
